export const selectMaterialPresets = (state) => state.materialPresets;
export const selectFreshMaterialPreset = (state) => state.materialPresets.freshMaterialPreset;
export const selectMaterialPresetAttributeDefinitions = (state) => state.materialPresets.attributeDefinitions;
